import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";

// JS Files
import MuiTheme from "../../../shares/MuiTheme";
import MuiTextFieldHook from "../../../shares/MuiTextFieldHook";
import MuiSelectHook from "../../../shares/MuiSelectHook";
import { TreatmentProvince } from "../../../../TreatmentProvince";
import MuiButton from "../../../shares/MuiButton";
import MuiModal from "../../../shares/MuiModal";
import { useLocation } from "react-router-dom";
import useFetch from "../../../../context/useFetch";
import { JBDateInput } from "jb-date-input-react";
import MuiUpload from "../../../shares/MuiUpload";

// import Others files

const genderList = [
  {
    name: "مرد",
    value: "male",
  },

  {
    name: "زن",
    value: "female",
  },
];
const relationList = [
  {
    name: "فرزند",
    value: "children",
  },

  {
    name: "همسر",
    value: "wife",
  },
  {
    name: "پدر",
    value: "father",
  },
  {
    name: "مادر",
    value: "mother",
  },
];

const StepThreeModal = (props) => {
  const location = useLocation();
  const {
    watch,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      name: "",
      gender: "",
      code: "",
      father_name: "",

      identity_num: "",

      birth_provience: "",
      birth_city: "",
      identify_provience: "",
      identify_city: "",
      relation: "",
    },
  });

  const [files, setFiles] = useState([
    {
      name: "شناسنامه - صفحه اول",
      value: "shenasname_1",
      file: null,
    },
    {
      name: "شناسنامه - صفحه دوم",
      value: "shenasname_2",
      file: null,
    },
  ]);

  const [postData, setPostData] = useState();
  const [birthDate, setBirthDate] = useState(undefined);

  const TreatmentRequestSubServiceApi = useFetch({
    url: `TreatmentRequestSubInsured_Service`,
    method: "POST",
    data: postData,
    trigger: false,
    argFunc: (res) => {
      if (res.data == "done") {
        reset();
        props.apiCall.reFetch();
        props.setOpenModal(false);
      }
    },
    errMessage: (res) => {},
  });

  const UpdateTreatmentRequestSubInsuredServiceApi = useFetch({
    // url: `TreatmentRequestSubInsured_Service/${}`,
    method: "PATCH",
    data: postData,
    trigger: false,
    argFunc: (res) => {
      // navigate("/step-two", {
      //   state: {
      //     treatmentRequestMainInsuredId: treatmentRequestMainInsuredId,
      //     treatmentRequestId: treatmentRequestId,
      //   },
      // });
    },
    errMessage: (res) => {},
  });

  const onSubmit = (data) => {
    const formData = new FormData();

    formData.append("name", data.name);
    formData.append("gender", data.gender);
    formData.append("code", data.code);
    formData.append("father_name", data.father_name);
    formData.append("birth_date", dayjs(birthDate).format("YYYY-MM-DD"));
    formData.append("birth_provience", data.birth_provience);
    formData.append("birth_city", data.birth_city);
    formData.append("identity_num", data.identity_num);
    formData.append("identify_provience", data.identify_provience);
    formData.append("identify_city", data.identify_city);
    formData.append("relation", data.relation);
    formData.append("p1_attach_file", files[0].file, files[0].file.name);
    formData.append("p2_attach_file", files[1].file, files[1].file.name);
    formData.append(
      "treatment_main_insured",
      location.state.treatmentRequestMainInsuredId
    );
    setPostData(formData);
    TreatmentRequestSubServiceApi.reFetch();
  };

  const addFile = (f, value) => {
    let before = [...files];
    before.filter((it) => it.value == value)[0]["file"] = f;
    setFiles(before);
  };

  console.log("amin", files);
  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-4/5"
        isOverflow
        isNotBackdropClick
      >
        <MuiButton
          onClick={() => props.setOpenModal(false)}
          variant="contained"
          color="error"
          text="بستن"
          size="small"
        />
        <p className="font-bold text-mygray-700 text-center border-b border-dashed pb-4">
          افزودن فرد تحت تکفل:
        </p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid md:grid-cols-4 gap-4 md:mt-8 mx-4 md:mx-12">
            <MuiTheme>
              <MuiTextFieldHook
                id="outlined-basic"
                variant="outlined"
                size="small"
                label="نام و نام‌خانوادگی"
                name="name"
                control={control}
                register={{
                  required: {
                    value: true,
                    message: "نام و نام خانوادگی را وارد کنید",
                  },
                }}
              />
              <MuiSelectHook
                size="small"
                inputLabel="جنسیت"
                label="gender"
                control={control}
                name="gender"
                register={{
                  required: {
                    value: true,
                    message: "جنسیت را انتخاب کنید",
                  },
                }}
                labelId="gender-label"
                id="gender-select"
                menuItems={genderList}
                fromApi={false}
              />
              <MuiTextFieldHook
                id="outlined-basic"
                variant="outlined"
                size="small"
                label="کد ملی"
                name="code"
                control={control}
                isLTR
                register={{
                  required: {
                    value: true,
                    message: "کدملی را وارد کنید",
                  },
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "کدملی باید ۱۰ رقم باشد.",
                  },
                }}
                type="number"
              />
              <MuiTextFieldHook
                id="outlined-basic"
                variant="outlined"
                size="small"
                label="نام پدر"
                name="father_name"
                control={control}
                register={{
                  required: {
                    value: true,
                    message: "نام پدر را وارد کنید",
                  },
                }}
              />
              <JBDateInput
                value={birthDate}
                onChange={(event) => {
                  setBirthDate(event.target.value);
                }}
              ></JBDateInput>
              {/* <MuiDateField
                value={birthDate}
                label="تاریخ تولد"
                onChange={(date) => {
                  setBirthDate(date);
                }}
              /> */}
              <MuiSelectHook
                size="small"
                inputLabel="استان محل تولد"
                label="birth_provience"
                control={control}
                name="birth_provience"
                register={{
                  required: {
                    value: true,
                    message: "استان محل تولد را انتخاب کنید",
                  },
                }}
                labelId="birth_provience-label"
                id="birth_provience-select"
                menuItems={TreatmentProvince.map((it) => {
                  return { name: it.name, value: it.value };
                })}
                fromApi={false}
              />
              <MuiSelectHook
                size="small"
                inputLabel="شهر محل تولد"
                label="birth_city"
                control={control}
                name="birth_city"
                register={{
                  required: {
                    value: true,
                    message: "شهر محل تولد را انتخاب کنید",
                  },
                }}
                labelId="birth_city-label"
                id="birth_city-select"
                menuItems={
                  watch("birth_provience") !== undefined &&
                  watch("birth_provience") !== ""
                    ? TreatmentProvince.filter(
                        (it) => it.value == watch("birth_provience")
                      )[0].cities.map((ci) => {
                        return {
                          name: ci,
                          value: ci,
                        };
                      })
                    : []
                }
                fromApi={false}
              />
              <MuiTextFieldHook
                id="outlined-basic"
                variant="outlined"
                size="small"
                label="شماره شناسنامه"
                name="identity_num"
                control={control}
                isLTR
                register={{
                  required: {
                    value: true,
                    message: "شماره شناسنامه را وارد کنید",
                  },
                }}
                type="number"
              />
              <MuiSelectHook
                size="small"
                inputLabel="استان محل صدور"
                label="identify_provience"
                control={control}
                name="identify_provience"
                register={{
                  required: {
                    value: true,
                    message: "استان محل صدور را انتخاب کنید",
                  },
                }}
                labelId="identify_provience-label"
                id="identify_provience-select"
                menuItems={TreatmentProvince.map((it) => {
                  return { name: it.name, value: it.value };
                })}
                fromApi={false}
              />
              <MuiSelectHook
                size="small"
                inputLabel="شهر محل صدور"
                label="identify_city"
                control={control}
                name="identify_city"
                register={{
                  required: {
                    value: true,
                    message: "شهر محل صدور را انتخاب کنید",
                  },
                }}
                labelId="identify_city-label"
                id="identify_city-select"
                menuItems={
                  watch("identify_provience") !== undefined &&
                  watch("identify_provience") !== ""
                    ? TreatmentProvince.filter(
                        (it) => it.value == watch("identify_provience")
                      )[0].cities.map((ci) => {
                        return {
                          name: ci,
                          value: ci,
                        };
                      })
                    : []
                }
                fromApi={false}
              />
              <MuiSelectHook
                size="small"
                inputLabel="نسبت با بیمه‌شده اصلی"
                label="relation"
                control={control}
                name="relation"
                register={{
                  required: {
                    value: true,
                    message: "نسبت با بیمه‌شده اصلی را انتخاب کنید",
                  },
                }}
                labelId="relation-label"
                id="relation-select"
                menuItems={relationList}
                fromApi={false}
              />
            </MuiTheme>
          </div>
          <span className="text-mygray-700 font-bold mt-8 block">
            بارگذاری مدارک:
          </span>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-4">
            {files.map((item, index) => {
              return (
                <div className="border border-dashed rounded-lg">
                  <span className="bg-gray-100 p-2 w-full text-center text-gray-500 text-sm rounded-t-lg block">
                    {item.name}
                  </span>
                  {item.file !== null && (
                    <div className="flex justify-center">
                      <img
                        className="h-32"
                        src={URL.createObjectURL(item.file)}
                      />
                    </div>
                  )}
                  <MuiUpload
                    setImageFile={(f) => addFile(f, item.value)}
                    accept="image/*"
                    id={item.value}
                  />
                </div>
              );
            })}
          </div>
          <div className="flex mt-4 justify-end">
            <MuiButton
              // onClick={() => navigate("/step-two")}
              // onClick={() => handleRemoveFileModal()}
              type="submit"
              variant="contained"
              color="primary"
              text={
                TreatmentRequestSubServiceApi.loading
                  ? "در حال ذخیره سازی"
                  : "افزودن"
              }
              disabled={
                files[0].file == null ||
                files[1].file == null ||
                birthDate == undefined ||
                TreatmentRequestSubServiceApi.loading
              }
              isFullWidth
            />
          </div>
        </form>
      </MuiModal>
    </>
  );
};

export default StepThreeModal;
